/* Progressive enhancements. Shopify owns products, cart, forms and checkout. */
(() => {
  'use strict';
  document.documentElement.classList.replace('no-js', 'js');
  const initialized = new WeakSet();
  const initOnce = (selector, init) => document.querySelectorAll(selector).forEach(el => {
    if (initialized.has(el)) return;
    initialized.add(el); init(el);
  });
  function initialize() {
    initOnce('.site-header', header => {
      const dialog = header.parentElement.querySelector('#MobileMenu');
      const open = header.querySelector('[data-open-menu]');
      if (dialog && open) {
        open.addEventListener('click', () => { dialog.showModal(); open.setAttribute('aria-expanded','true'); });
        dialog.querySelector('[data-close-menu]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('close', () => { open.setAttribute('aria-expanded','false'); open.focus(); });
        dialog.addEventListener('click', e => { if(e.target === dialog) { const r=dialog.getBoundingClientRect(); if(e.clientX<r.left||e.clientX>r.right) dialog.close(); } });
      }
      header.addEventListener('keydown', e => {
        if (e.key !== 'Escape') return;
        const details=e.target.closest('details[open]');
        if(details){details.open=false;details.querySelector('summary').focus();}
      });
    });
    initOnce('[data-video-toggle]', button => {
      const video=button.closest('.hero').querySelector('video');
      if(!video)return;
      const update=()=>{button.textContent=video.paused?'Play video':'Pause video';button.setAttribute('aria-label',video.paused?'Play background video':'Pause background video');};
      if(matchMedia('(prefers-reduced-motion: reduce)').matches || document.body.classList.contains('motion-off')) video.pause();
      button.addEventListener('click',()=>{if(video.paused){video.play().catch(()=>update());}else video.pause();});
      video.addEventListener('play',update);video.addEventListener('pause',update);update();
    });
    initOnce('[data-ticker-toggle]', button => {
      const track=button.closest('.ticker').querySelector('.ticker__track');
      button.addEventListener('click',()=>{const paused=button.getAttribute('aria-pressed')!=='true';button.setAttribute('aria-pressed',String(paused));button.textContent=paused?'Play':'Pause';track.style.animationPlayState=paused?'paused':'';});
    });
    initOnce('[data-product-section]', section => {
      const selector=section.querySelector('[data-variant-select]');
      if(selector) selector.addEventListener('change',()=>{
        const option=selector.options[selector.selectedIndex];
        section.querySelector('[data-product-price]').textContent=option.dataset.price;
        const compare=section.querySelector('[data-product-compare]');
        compare.textContent=option.dataset.compare;compare.hidden=!option.dataset.compare;
        const button=section.querySelector('[data-add-button]');
        button.disabled=option.dataset.available!=='true';
        button.querySelector('[data-add-label]').textContent=button.disabled?'SOLD OUT':'ADD TO BAG';
        const sticky=section.closest('section').querySelector('[data-sticky-price]');
        if(sticky)sticky.textContent=option.dataset.price;
        const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);
        const media=section.querySelector(`#Media-${CSS.escape(option.dataset.media||'')}`);
        if(media){const gallery=section.querySelector('.product-gallery');if(matchMedia('(max-width:749px)').matches){gallery.scrollTo({left:media.offsetLeft-gallery.offsetLeft,behavior:'smooth'});}else{media.scrollIntoView({block:'nearest',behavior:'smooth'});}}
      });
    });
    initOnce('#PrayerRequestForm', form => {
      form.addEventListener('submit',()=>{
        const email=form.querySelector('[data-prayer-email]');const delivery=form.querySelector('[data-prayer-delivery-email]');
        if(email?.value.trim())delivery.value=email.value.trim();
      });
    });
    initOnce('[data-spotify]', host => {
      const toggle=host.querySelector('[data-spotify-toggle]'), panel=host.querySelector('.soundtrack__panel');
      let playlist;
      try{const url=new URL(host.dataset.url);const parts=url.pathname.split('/').filter(Boolean);const index=parts.indexOf('playlist');if(url.hostname==='open.spotify.com'&&index!==-1&&/^[a-zA-Z0-9]{22}$/.test(parts[index+1]||''))playlist=parts[index+1];}catch{}
      function open(){
        panel.hidden=false;toggle.setAttribute('aria-expanded','true');
        if(!playlist){host.querySelector('[data-spotify-error]').hidden=false;host.querySelector('[data-spotify-external]').hidden=true;return;}
        if(!host.querySelector('iframe')){
          const frame=document.createElement('iframe');frame.title='Last Day Warriors Spotify playlist';frame.src=`https://open.spotify.com/embed/playlist/${playlist}?utm_source=generator&theme=0`;frame.allow='autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture';frame.loading='lazy';frame.allowFullscreen=true;
          host.querySelector('[data-spotify-frame]').append(frame);
          host.querySelector('[data-spotify-external]').href=`https://open.spotify.com/playlist/${playlist}`;
        }
      }
      function close(){panel.hidden=true;toggle.setAttribute('aria-expanded','false');toggle.focus();}
      toggle.addEventListener('click',()=>panel.hidden?open():close());
      host.querySelector('[data-spotify-close]').addEventListener('click',close);
      host.addEventListener('keydown',e=>{if(e.key==='Escape')close();});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
